import cfg, {formatStatusError, handleResponse, UPDATE_LANGUAGE, handlePrepareData} from "../constants";
import {authMiddleware, storeLanguage} from "./loginAction";


// getProfileAction - get user profile
export const getProfileAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/user-get-profile', {
    method: "GET",
    headers: headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      return data.user;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// updateProfileAction - save user profile
export const updateProfileAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/user-edit-profile', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      if (body.language) {
        storeLanguage(body.language);
        dispatch({type: UPDATE_LANGUAGE, lang: body.language});
      }
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// uploadProfilePhotoAction - upload user avatar
export const uploadProfilePhotoAction = (file) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  return new Promise((resolve, reject) => {
    const formData = new FormData();

    if (file && file.name) {
      formData.append("file", file, file.name);
    }

    const req = new XMLHttpRequest();
    req.addEventListener("load", event => {
      if (req.status === 200) {
        try {
          let data = JSON.parse(req.response);
          if (data.status === 'ok') {
            resolve(data);
          } else if (data.errors && data.errors.length > 0) {
            reject(new Error(data.errors[0]));
          } else {
            reject(new Error('error_other'));
          }
        } catch (e) {
          reject(new Error('error_other'));
        }
      } else {
        reject(formatStatusError(req.status));
      }
    });

    req.upload.addEventListener("error", event => {
      reject(req.response);
    });

    req.open("POST", cfg.base_url + '/auth/user-edit-profile-photo');
    req.setRequestHeader("Authorization", 'Bearer ' + token);
    req.send(formData);
  });
};

export const changeDayOffAction = (checked) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/user-change-day-off', {
    method: "POST",
    headers: headers,
    body: JSON.stringify({day_off: checked})
  }).then(handleResponse).then(handlePrepareData);
};
